import axios from 'axios';
import { authHeader } from '../_helpers';
import config from '../_helpers/_config';

export const userService = {
    getUser,
    editUser,
    changePassword
};

async function getUser(username) {
    const req_config = {
        headers: authHeader()
    };

    return axios.get(`${config.API_LOCATION}/user/${username}`, req_config);
}

async function editUser(userId, jsonData) {
    return axios({
        method: 'put',
        url: `${config.API_LOCATION}/user/edit/${userId}`,
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
        data: jsonData
    });
}

async function changePassword(userId, oldPassword, newPassword) {
    oldPassword = window.btoa(oldPassword);
    newPassword = window.btoa(newPassword);
    return axios({
        method: 'put',
        url: `${config.API_LOCATION}/authuser/edit/pass/${userId}`,
        headers: Object.assign({ 'Content-Type': 'application/json' }, authHeader()),
        data: JSON.stringify({ oldPassword, newPassword })
    });
}
